import { render, staticRenderFns } from "./VGame.vue?vue&type=template&id=5f9376d2&scoped=true&"
import script from "./VGame.vue?vue&type=script&lang=js&"
export * from "./VGame.vue?vue&type=script&lang=js&"
import style0 from "./VGame.vue?vue&type=style&index=0&id=5f9376d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9376d2",
  null
  
)

export default component.exports